import React from "react";
import styled from "styled-components";
import { getIconName, iconName } from "../icons/Icons";
import { ButtonHover, ButtonStyle, ButtonVariant, IconWrapper } from "./Shared";
import { TooltipTheOneWrapper } from "../TooltipTheOne";


type LinkButtonProps = {
    variant:ButtonVariant;
    disabled?: boolean;
    heightOverride?: string;
    download?:string;
    icon?: iconName;
    iconPosition?: 'left' | 'right';
    text?: string;
    href:string;
    target?:'_blank'|'_self'|'_parent'|'_top';
    rel?:string;
    tooltipContent?:React.ReactNode;
    tooltipHorizontalAlignment?: 'left' | 'right';
    onClick?:()=>void;
}


export function LinkButton(props: LinkButtonProps): JSX.Element {

    const isDisabled = props.disabled !== undefined && props.disabled === true;
    const target = props.target || '_self';

    const btn = <LinkButtonWrapper 
            variant={props.variant} 
            icon={props.icon} 
            iconPosition={props.iconPosition}
            disabled={props.disabled} 
            heightOverride={props.heightOverride} 
            href={isDisabled ? undefined : props.href}
            target={isDisabled ? undefined : target}
            role={isDisabled ? 'link' : undefined}
            aria-disabled={isDisabled ? 'true' : 'false'}
            download={props.download || undefined}
            rel={props.rel}>
            {props.icon && (
                <IconWrapper variant={props.variant}>{getIconName(props.icon)}</IconWrapper>
            )}
            {props.text && (
                <span>{props.text}</span>
            )}
            <ButtonHover variant={props.variant}></ButtonHover>
        </LinkButtonWrapper>;


    return props.tooltipContent 
        ?   <TooltipTheOneWrapper tooltipContent={props.tooltipContent} horizontalAlignment={props.tooltipHorizontalAlignment}>
                {btn}
            </TooltipTheOneWrapper>
        : btn
}

const LinkButtonWrapper = styled.a<{ variant: ButtonVariant, icon?: iconName, iconPosition?: 'left' | 'right', heightOverride?:string, disabled?: boolean }>`
    ${ButtonStyle}
`